import { EMAIL_CHANGE_MODES, getEmailChangeLinkIntent, getPendingEmailChange } from './pendingEmailChange';

// Email-change actions retain their existing account-bound handler. All other
// emailed sign-in actions belong to Mobile, even when the URL is incomplete.
export const isMobileSignInLink = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  if (params.get('mode') !== 'signIn') return false;
  if (getEmailChangeLinkIntent(search)) return false;
  try {
    return !getPendingEmailChange({ mode: EMAIL_CHANGE_MODES.LINK });
  } catch (_) {
    // Unavailable browser storage must never enable URL-based Manager login.
    return true;
  }
};

export const getMobileSignInUrl = (href = window.location.href) => {
  try {
    const url = new URL(href);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
    const params = url.searchParams;
    if (params.get('mode') !== 'signIn' ||
      ['mode', 'apiKey', 'oobCode'].some((key) => params.getAll(key).length !== 1 || !params.get(key))) return null;
    // Both native apps already register this scheme and pass the complete URL
    // to Firebase. Preserve the original query bytes, including nested state.
    return url.href.replace(/^https?:/, 'playerdex:');
  } catch (_) {
    return null;
  }
};

export const isMobileBrowser = (browser = navigator) =>
  /Android|iPhone|iPad|iPod/i.test(browser.userAgent) ||
  (/Macintosh/i.test(browser.userAgent) && browser.maxTouchPoints > 1);

export const openPlayerDexApp = () => {
  const url = getMobileSignInUrl();
  if (url) window.location.assign(url);
};
